import { useTranslation } from "next-i18next";
import { ITagsData } from "src/api/server/extended-search.types";
import { TagsListWithBrokers } from "src/components/pages/search/components/tags-filter/components/tags-list-with-brokers";
import { FilterCategoryItem } from "../filter-category-item";

interface ITagsFilter {
    tagsData: ITagsData;
    numberOfSelectedTags: number;
}

export const TagsFilter = ({ tagsData, numberOfSelectedTags }: ITagsFilter) => {
    const { t } = useTranslation("extended-search");

    const { basics, tradings, rewards, investmentHorizon, investmentRegion, alphaBeta } = tagsData.tags;
    const numbersOfTags =
        basics.tags.length +
        tradings.tags.length +
        rewards.tags.length +
        investmentHorizon.tags.length +
        investmentRegion.tags.length +
        alphaBeta.tags.length;

    return (
        <FilterCategoryItem title={t("tags")} badgeInfo={`${numberOfSelectedTags} / ${numbersOfTags}`}>
            <TagsListWithBrokers tagsData={tagsData} />
        </FilterCategoryItem>
    );
};
